<template>
  <div id="my-invitation">
    <div class="head-wrapper panel__header">
      <div class="invite-btn-box">
        <button class="qrcode_handle_btn" type="button" @click="openDialogVisible">
          邀请用户
        </button>
      </div>
      <div class="search-inp-box flex items-center">
        <div class="qrcode_input" style="width: 300px; margin-right: 15px">
          <el-select
            v-model="projectID"
            placeholder="请选择项目名称"
            style="width: 100%"
            @change="refreshTable"
          >
            <el-option
              v-for="item in projectOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>

        <div class="qrcode_input" style="width: 300px">
          <el-input
            v-model.trim="condition"
            placeholder="搜索姓名/手机/邮箱/项目"
            @keyup.enter.native="refreshTable"
          >
          </el-input>
        </div>

        <span class="search-btn-box" @click="conditionSearch"
          ><i class="el-icon-search icon-style"></i
        ></span>
      </div>
    </div>

    <div class="panel__body">
      <el-table ref="tableData" v-loading="loading" :data="tableData" height="calc(100vh - 210px)">
        <el-table-column label="" prop="" width="55">
          <template slot-scope="scope">
            <img
              v-if="scope.row.UserHeadImgUrl == null"
              alt="头像"
              src="../../assets/images/icon/icon_header_avatar-default.svg"
              style="width: 30px; height: 30px"
            />
            <img
              v-else
              :src="scope.row.UserHeadImgUrl"
              alt="头像"
              style="width: 30px; height: 30px"
            />
          </template>
        </el-table-column>
        <el-table-column label="姓名" prop="UserName" width=""></el-table-column>
        <el-table-column label="手机" prop="MobilePhone" width=""></el-table-column>
        <el-table-column label="邮箱" prop="UserEmail" width=""></el-table-column>
        <el-table-column
          label="最近一次登录"
          prop="LastLoginDateTimeDisplay"
          width=""
        ></el-table-column>
        <el-table-column label="工作项目/角色" prop="RoleName" width="">
          <template slot-scope="scope">
            <span>{{ scope.row.ProjectName }}/{{ scope.row.RoleName }}</span>
            <el-popover
              v-if="scope.row.OtherProjectRoleList.length > 0"
              placement="bottom-end"
              trigger="hover"
              width="450"
              @show="handleRoleChange(scope.row.OtherProjectRoleList)"
            >
              <el-table :data="roleData" :show-header="false">
                <el-table-column label="工作项目/角色" prop="" width="250">
                  <template slot-scope="role">
                    <span>{{ role.row.ProjectName }}/{{ role.row.ProjectRole }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="最后一次登录"
                  prop="LastLoginDateTime"
                  width="150"
                ></el-table-column>
              </el-table>
              <span v-if="scope.row.OtherProjectRoleList.length > 0" slot="reference">
                <img
                  alt="权限"
                  src="../../assets/images/icon/icon_table-jurisdiction.png"
                  style="width: 18px; height: 18px; vertical-align: middle; margin-left: 2px"
                />
              </span>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="" prop="" width="80">
          <template slot-scope="scope">
            <img
              alt="删除"
              class="opinion-tab-btn iconfont-table-operate"
              src="../../assets/images/icon/icon_table_delete.png"
              title="删除"
              @click="removeOwnedUser(scope.row.ID)"
            />
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container flex flex-row items-center justify-end">
        <el-pagination
          :current-page="currentPage"
          :page-size="pageSize"
          :page-sizes="[10, 15, 20, 50]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      :visible.sync="dialogVisible"
      width="460px"
    >
      <div slot="title">
        <span v-if="!generateLink" class="b-modal-title">邀请新用户</span>
        <span v-if="generateLink" class="b-modal-title">邀请链接生成成功</span>
      </div>
      <el-form ref="formData" :model="formData" :rules="rules">
        <div v-if="!generateLink" class="b-flex b-flex-space-between">
          <div class="qrcode_input">
            <el-form-item label="选择项目" prop="projectID">
              <el-select v-model="formData.projectID" placeholder="请选择">
                <el-option
                  v-for="item in projectOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div v-if="generateLink" class="b-flex b-flex-space-between qrcode_input">
          <div
            v-loading="qrCodeLoading"
            customClass="loading-all"
            element-loading-background="rgba(255, 255, 255,1)"
            element-loading-custom-class="loading-all"
            element-loading-text="生成邀请二维码...请稍等"
            style="text-align: center; height: 300px"
          >
            <div
              id="poster-container"
              style="display: flex; justify-content: center; align-items: center; flex-flow: column"
            >
              <div>
                <span style="color: #888888">{{ qrCode.UserDisplayName }}</span>
                <span style="color: #888888">邀请您加入二维码平台</span>
              </div>
              <p style="margin: 0.25em 0 1em; color: rgb(34, 34, 34); font-weight: bold">
                "{{ qrCode.ProjectName }}"项目
              </p>
              <div id="img-father" style="background: transparent">
                <vue-qrcode
                  :color="colors"
                  :margin="margin"
                  :quality="quality"
                  :type="type"
                  :value="qrcodeValue"
                  :width="width"
                ></vue-qrcode>
              </div>
            </div>
            <span class="bottom-alert">
              <span style="display: inline-block; width: 150px">截图或右键复制图片到微信</span>
            </span>
          </div>
        </div>
      </el-form>
      <div v-if="!generateLink" slot="footer" class="b-flex" style="justify-content: flex-end">
        <button
          class="qrcode_handle_btn"
          title="生成链接"
          type="button"
          @click="makeInvitationToke"
        >
          生成链接
        </button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import html2canvas from 'html2canvas'
import VueQrcode from 'vue-qrcode'

let _this = void 0
export default {
  name: 'MyInvitationQrCode',
  components: {
    VueQrcode,
  },
  filters: {},
  directives: {},
  mixins: [],
  props: {},
  data() {
    return {
      // 表格数据
      tableData: [],
      loading: false,
      currentPage: 0,
      pageSize: 10,
      total: 0,
      projectID: '',
      // 项目列表
      projectOptions: [],
      // 模糊搜索条件
      condition: '',
      dialogVisible: false,
      roleData: [],
      formData: {
        projectID: null,
        link: null,
      },
      rules: {
        projectID: [{ required: true, message: '请选择项目', trigger: 'change' }],
      },
      qrCode: {
        UserDisplayName: null,
        ProjectName: null,
      },
      modelTitle: '邀请新用户',
      generateLink: false,
      wxURL: '', // 微信Url
      socket: null,
      qrcodeSrcWeChat: '',
      showQrCode: true,
      ticket: '',
      qrCodeLoading: true,
      // 二维码生成图片的格式
      type: 'image/png',
      // 二维码色块值   width: 187,
      colors: {
        dark: '#000000FF',
        light: '#FFFFFFFF',
      },
      // 二维码外边距(px)
      margin: 0,
      // 二维码质量 0~1
      quality: 1,
      // 二维码边长(px)
      width: 187,
      // 二维码值
      qrcodeValue: '自定义标题',
    }
  },
  computed: {
    // ...mapState('', {}),
  },
  watch: {},
  async created() {
    _this = this
    await this.getUrl()
    await this.getSocket()
    window.onunload = function deleteTimer() {
      _this.socket.close()
      clearInterval(timer)
    }
  },
  mounted() {
    this.refreshTable()
    this.getUserProjectData()
    this.qrCode.UserDisplayName = JSON.parse(localStorage.getItem('USER_INFO')).DisplayName
  },
  destroy() {},
  methods: {
    // ...mapMutations('', []),
    ...mapGetters('user', {
      getUserInfo: 'USER_INFO',
    }),
    /*
     * 复制二维码
     * */
    copyQR() {
      const _ = this
      const imgFather = document.getElementById('poster-container')
      if (imgFather.innerHTML !== '') {
        const img = document.getElementById('poster-container')
        img.focus()
        this.$nextTick(() => {
          html2canvas(img, {
            imageTimeout: 2e3,
          }).then(() =>
            html2canvas(imgFather).then(canvas => {
              const image = new Image()
              image.className = 'image-post'
              image.src = canvas.toDataURL('image/png')
              if (document.querySelector('#poster-container')) {
                document.querySelector('#poster-container').innerHTML = ''
                document.querySelector('#poster-container').appendChild(image)
              }
              _.qrCodeLoading = false
            }),
          )
        })
      }
    },
    /*
     * 获取二维码链接
     * */
    async getUrl() {
      const _ = this
      const { success, data } = await this.$http({
        url: '/api/UserActivation/GetUserActivationUrl',
        method: 'Get',
      })
      if (success) {
        _.wxURL = data.WSURL
      } else {
        this.$message({
          type: 'error',
          message: '微信登录失败！',
        })
      }
    },
    /*
     * 获取列表成员管理数据
     * */
    async getOwnedUserData() {
      this.loading = true
      const { success, data } = await this.$http({
        url: this.$api.getOwnedUserPageList,
        params: {
          condition: this.condition,
          projectID: this.projectID,
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
        },
      })
      if (success) {
        const { total, rows } = data
        // 上次登录时间格式处理
        for (const item of rows) {
          item.LastLoginDateTime = item.LastLoginDateTime.replace('T', ' ')
          if (item.LastLoginDateTime.indexOf('0001-01-01') !== -1) {
            item.LastLoginDateTime = ''
          }
        }

        this.total = total
        this.tableData = [...rows]
        this.loading = false
      } else {
        this.$message({
          type: 'error',
          message: '获取用户数据失败！',
        })
      }
    },
    /*
     * 刷新表格，用户初始化
     * */
    refreshTable() {
      this.currentPage = 0
      this.pageSize = 10
      this.getOwnedUserData()
    },
    /*
     * 每页数数据获取变更触发
     * @parma pageSize {number} 一次返回多少条数据
     * */
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.getOwnedUserData()
    },
    /*
     * 页码变更触发
     * @parma pageNumber {number} 页码数，返回需要-1处理
     * */
    handleCurrentChange(pageNumber) {
      this.currentPage = pageNumber - 1
      this.getOwnedUserData()
    },
    /*
     * 点击搜索按钮，添加查询
     * */
    conditionSearch() {
      this.refreshTable()
    },
    /*
     * 显示角色信息
     * @parma row {object} 列表单条数据
     * */
    handleRoleChange(row) {
      for (const item of row) {
        item.LastLoginDateTime = item.LastLoginDateTime.replace('T', ' ')
        if (item.LastLoginDateTime.indexOf('0001-01-01') !== -1) {
          item.LastLoginDateTime = ''
        }
      }
      this.roleData = row
    },
    /*
     * 获取用户项目列表数据
     * */
    async getUserProjectData() {
      const { success, data } = await this.$http({
        url: this.$api.getUserManagedProjects,
      })
      if (success) {
        const { item } = data
        const _projectList = []
        for (const v of item) {
          const option = { label: v.Name, value: v.ID }
          _projectList.push(option)
        }
        _this.projectOptions = [..._projectList]
      } else {
        this.$message({
          type: 'error',
          message: '获取项目列表失败！',
        })
      }
    },
    /*
     * 点击移除按钮弹出框
     * @parma id {number} 用户ID
     * */
    async removeOwnedUser(id) {
      this.$confirm('确定移除当前用户?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        confirmButtonClass: 'qrcode_modal_confirm_btn',
        cancelButtonClass: 'qrcode_modal_cancel_btn',
      }).then(async () => {
        await this.commitRemoveUser(id)
      })
    },
    /*
     * 提交删除用户接口
     * @param userID {number} 要删除用户的ID
     * */
    async commitRemoveUser(userID) {
      const { success } = await this.$http({
        url: this.$api.removeOwnedUser,
        params: {
          userID,
        },
      })
      this.$message({
        type: success ? 'success' : 'error',
        message: success ? '删除成功！' : '删除失败！',
      })
    },
    /*
     * 初始化邀请弹框
     * */
    openDialogVisible() {
      this.qrcodeSrcWeChat = ''
      this.generateLink = false
      if (this.$refs.formData !== undefined) {
        this.$refs.formData.clearValidate()
      }
      if (this.projectOptions.length !== 0) {
        if (this.formData.projectID == null) {
          this.formData.projectID = this.projectOptions[0].value
        }
        this.dialogVisible = true
      } else {
        this.$message({
          type: 'error',
          message: '当前没有可邀请的项目，请您先创建项目',
        })
      }
    },
    /*
     * 根据项目ID,生成链接
     * */
    async makeInvitationToke() {
      this.qrCodeLoading = true
      this.generateLink = true
      const { projectID } = this.formData
      console.log(this.formData)
      for (const item of this.projectOptions) {
        if (item.value === projectID) {
          this.qrCode.ProjectName = item.label
        }
      }
      if (projectID) {
        const { success, data } = await this.$http({
          url: `${this.$api.makeInvitationToke}?projectID=${projectID}`,
          method: 'post',
        })
        if (success) {
          this.formData.link = data
          this.qrcodeValue = data
          _this.copyQR()
        }
        this.$message({
          type: success ? 'success' : 'error',
          message: success ? '生成链接成功！' : '生成链接失败！',
        })
      }
    },
    /**
     * 通知server返回信息
     * @param ticket {string} 凭证
     */
    sendSocketTicket(ticket) {
      this.socket.send(
        JSON.stringify({
          Module: 'Common',
          Action: 'SetCurrentUserByUniqueIdentification',
          Param: {
            UniqueIdentification: ticket,
            Channel: 'Web',
          },
        }),
      )
    },
    /**
     * 获取serve返回的信息
     */
    getSocket() {
      this.socket = new WebSocket(this.wxURL)
      this.socket.addEventListener('open', () => {})
      this.socket.addEventListener('message', event => {
        const data = JSON.parse(event.data)
        if (data.Success) {
          _this.userToken = data.Param.Token
        }
      })
    },
    getBase64Image(img) {
      const canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      const ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0, img.width, img.height)
      // 图片的格式
      const ext = img.src.substring(img.src.lastIndexOf('.') + 1).toLowerCase()
      return canvas.toDataURL(`image/${ext}`)
    },
  },
}
</script>
<style lang="scss" scoped>
#my-invitation {
  background-color: #ffffff;
  border-radius: 4px;

  .head-wrapper {
    background-color: #ffffff;

    .invite-btn-box {
      flex: 1;
    }

    .search-inp-box {
      flex: 2;
      display: flex;
      flex-wrap: nowrap;
      justify-content: flex-end;
      border: none;
    }
  }

  .panel__body {
    .iconfont-table-operate {
      display: none !important;
      color: #409eff;
      font-size: 18px;
      cursor: pointer;
    }

    .el-table__row:hover .iconfont-table-operate {
      display: inline-block !important;
    }
  }

  .el-dialog .qrcode_input ::v-deep .el-select {
    width: 347px !important;
  }

  ::v-deep .el-dialog__body {
    padding-bottom: 0 !important;
  }

  ::v-deep .el-dialog__footer {
    padding-top: 0;
  }
}

.icon-style {
  font-size: 22px;
  color: #ffffff;
}

.altTipQrCode {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  height: 250px;
  width: 250px;
}

#poster-container {
  position: relative;
  height: 271px;
}

.bottom-alert {
  display: block;
  font-size: 12px;
  color: #bababa;
  margin-top: 0.5em;
  padding-bottom: 0.5em;
}

.loading-all .circular {
  width: 48px !important;
  height: 48px !important;
}

.loading-all {
  margin-bottom: -1.5em;
}

#img-father {
  width: 250px;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.opinion-tab-btn {
  width: 22px;
  height: 22px;
}
</style>
<style lang="scss"></style>
